import React from 'react';

import type { IRibbonBtnNullConfig } from './RibbonConfig';

import styles from './RibbonNullButton.module.scss';
import { Box } from '@mui/material';
import { upperCaseBegin } from '../../../utils/stringUtils';
import { GlobalVariables } from '../../../pdf/GlobalVariables';

export default (props: IRibbonBtnNullConfig) => {
    return (
        <Box
            id={
                GlobalVariables.isForTestRun
                    ? `rbnNullBtn${upperCaseBegin(props.config.Key)}`
                    : undefined
            }
            className={styles.button}
        >
            &nbsp;
        </Box>
    );
};
